var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSparkles = function SvgSparkles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7088 5.49421C9.10336 5.49421 9.45366 5.74669 9.57843 6.12101L10.9231 10.1549L14.957 11.4996C15.3313 11.6244 15.5838 11.9747 15.5838 12.3692C15.5838 12.7638 15.3313 13.1141 14.957 13.2388L10.9231 14.5835L9.57843 18.6174C9.45366 18.9917 9.10336 19.2442 8.7088 19.2442C8.31424 19.2442 7.96395 18.9917 7.83918 18.6174L6.49453 14.5835L2.46059 13.2388C2.08628 13.1141 1.8338 12.7638 1.8338 12.3692C1.8338 11.9747 2.08628 11.6244 2.46059 11.4996L6.49453 10.1549L7.83918 6.12101C7.96395 5.74669 8.31424 5.49421 8.7088 5.49421ZM8.7088 9.30963L8.08884 11.1695C7.9976 11.4432 7.78281 11.658 7.50909 11.7493L5.64922 12.3692L7.50909 12.9892C7.78281 13.0804 7.9976 13.2952 8.08884 13.5689L8.7088 15.4288L9.32876 13.5689C9.42 13.2952 9.63479 13.0804 9.90851 12.9892L11.7684 12.3692L9.90851 11.7493C9.63479 11.658 9.42 11.4432 9.32876 11.1695L8.7088 9.30963Z",
    fill: "#4352BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0421 2.19421C16.2789 2.19421 16.489 2.3457 16.5639 2.57029L17.279 4.71565L19.4244 5.43077C19.649 5.50563 19.8005 5.71581 19.8005 5.95255C19.8005 6.18928 19.649 6.39946 19.4244 6.47432L17.279 7.18944L16.5639 9.33481C16.489 9.55939 16.2789 9.71088 16.0421 9.71088C15.8054 9.71088 15.5952 9.55939 15.5204 9.33481L14.8052 7.18944L12.6599 6.47432C12.4353 6.39946 12.2838 6.18928 12.2838 5.95255C12.2838 5.71581 12.4353 5.50563 12.6599 5.43077L14.8052 4.71565L15.5204 2.57029C15.5952 2.3457 15.8054 2.19421 16.0421 2.19421Z",
    fill: "#4352BE"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSparkles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sparkles.1d88647a.svg";
export { ForwardRef as ReactComponent };